<template>
  <div class="allCarType">
    <div class="nav" :class="{ isiOSX: isiOSX }"></div>
    <div class="content">
      <div class="list" v-for="(item, index) in list" :key="index">
        <h2>{{ item.name }}</h2>
        <div class="out">
          <div
            class="in"
            v-for="(initem, i) in item.carList"
            :key="i"
            @click="select(item.typeName, initem, index, i)"
            data-checked="unchecked"
            :class="{ active: initem.selected }"
          >
            <p class="title">预估</p>
            <p class="money" @click.stop="moneyDetail(initem)">
              <span
                :class="
                  parseInt(initem.estimate_price).toString().length > 2
                    ? 'morlong'
                    : ''
                "
                >{{ initem.estimate_price | moneyFormat }}</span
              >
              元
              <img
                src="./../../assets/takingCar/moreright.png"
                alt
                v-if="initem.is_prices_detail == 1"
              />
            </p>
            <p class="integral">
              赠积分
              <span
                class="integralIn"
                :class="{ activeIntegral: initem.selected }"
                >{{ initem.credits | moneyFormat }}</span
              >
            </p>
            <p class="carName">
              <img
                src="./../../assets/takingCar/caocao.png"
                alt
                v-if="initem.short_name == 'CaoCao'"
              />
              <img
                src="./../../assets/takingCar/yangguang.png"
                alt
                v-if="initem.short_name == 'YangGuang'"
              />
              {{ initem.platform_name }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <button class="left" @click="packUp()">收起</button>
      <van-button
        type="primary"
        class="right"
        @click="toCall()"
        :class="checkedList.length > 0 && disble ? '' : 'forbid'"
        v-if="order_type == 1"
        :loading="!disble"
        loading-text="正在为您呼叫中..."
      >
        <span v-if="checkedList.length == 0" class="title">立即呼叫</span>
        <span v-if="checkedList.length == 0" class="tip"
          >请至少选择1种车型</span
        >
        <span v-if="checkedList.length == 1" class="title">立即呼叫</span>
        <span v-if="checkedList.length > 1" class="title"
          >同时呼叫{{ checkedList.length }}种车型</span
        >
      </van-button>
      <van-button
        type="primary"
        class="right"
        @click="toCall()"
        :class="checkedList.length > 0 && disble ? '' : 'forbid'"
        v-if="order_type != 1"
        :loading="!disble"
        loading-text="正在为您呼叫中..."
      >
        <span class="title">预约用车</span>
        <span v-if="checkedList.length == 0" class="tip"
          >请至少选择1种车型</span
        >
        <span v-else class="tip">已选择{{ checkedList.length }}种车型</span>
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      list: [],
      duration_time: "",
      checkedList: [],
      longitude: "121.59507",
      latitude: "29.81691",
      to_longitude: "120.205299",
      to_latitude: "30.275765",
      order_type: "1",
      start_time: "",
      city: "",
      start_name: "",
      end_name: "",
      car_type_array: [],
      disble: true,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
    this.formatting();
    this.getCarList();
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  watch: {
    $route: "getPath",
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(to);
      // console.log(from);
      if (from.path == "/takingCar/moneyDetail") {
        // console.log('详情')
        vm.car_type_array = JSON.parse(sessionStorage.getItem("allCarData"));
        // console.log(JSON.parse(sessionStorage.getItem("allCarData")));
      } else {
        // console.log('1111')
        if (vm.$route.query.car_type_array) {
          vm.car_type_array = JSON.parse(vm.$route.query.car_type_array);
        } else {
          vm.car_type_array = [];
        }
      }
    });
  },
  methods: {
    // 获取原生传的数据
    formatting() {
      this.longitude = this.$route.query.longitude || "";
      this.latitude = this.$route.query.latitude || "";
      this.to_longitude = this.$route.query.to_longitude || "";
      this.to_latitude = this.$route.query.to_latitude || "";
      this.order_type = this.$route.query.order_type || "";
      this.start_time = this.$route.query.start_time || "";
      this.city = this.$route.query.city || "";
      this.start_name = this.$route.query.start_name || "";
      this.end_name = this.$route.query.end_name || "";
    },
    // 匹配选中车型
    mateCar() {
      this.car_type_array.forEach((item) => {
        this.list.forEach((i) => {
          i.carList.forEach((j) => {
            if (item.id == j.id) {
              j.selected = true;
              j.tabPosition = item.tabPosition;
              j.position = item.position;
              this.checkedList.push(j);
            }
          });
        });
      });
    },
    packUp() {
      let checkArr = [];
      //  console.log("收起");
      this.checkedList.forEach((item) => {
        let checkData = {
          short_name: item.short_name,
          car_type_number: item.car_type_number,
          car_type_name: item.car_type_name,
          estimate_time: item.estimate_time,
          estimate_price: item.estimate_price,
          id: item.id,
          tabPosition: item.tabPosition,
          position: item.position,
        };
        checkArr.push(checkData);
      });
      // console.log(checkArr);
      let param = JSON.stringify(checkArr);
      this.params(param, param, "packUp");
    },
    // 呼叫汽车
    toCall() {
      if (this.checkedList.length > 0) {
        let checkArr = [];
        if (this.disble) {
          this.disble = false;
          // console.log("呼叫汽车");
          // console.log(this.checkedList);
          this.checkedList.forEach((item) => {
            let checkData = {
              short_name: item.short_name,
              car_type_number: item.car_type_number,
              car_type_name: item.car_type_name,
              estimate_time: item.estimate_time,
              estimate_price: item.estimate_price,
              id: item.id,
              tabPosition: item.tabPosition,
              position: item.position,
            };
            checkArr.push(checkData);
          });
          // console.log(checkArr);
          let param = JSON.stringify(checkArr);
          this.params(param, param, "toCall");
        }
      } else {
        this.$toast("请至少选择1种车型");
      }
    },
    // 选择
    select(name, item, index, i) {
      item.selected = !item.selected;
      this.list = [...this.list];
      item.tabPosition = index;
      item.position = i;
      if (item.selected) {
        this.checkedList.push(item);
      } else {
        // 取消选中，判断数组中是否已选，存在则删除
        let num = this.checkedList.indexOf(item);
        if (num > -1) {
          this.checkedList.splice(num, 1);
        }
      }
    },
    moneyDetail(item) {
      console.log(item);
      if (item.is_prices_detail == 1) {
        sessionStorage.setItem("allCarData", JSON.stringify(this.checkedList));
        this.$router.push({
          path: "/takingCar/moneyDetail",
          query: {
            item: JSON.stringify(item),
            duration_time: this.duration_time,
            type: "all",
          },
        });
      }
    },
    getCarList() {
      this.$api
        .post("/taxis/member/order/car/list", {
          longitude: this.longitude,
          latitude: this.latitude,
          to_longitude: this.to_longitude,
          to_latitude: this.to_latitude,
          order_type: this.order_type,
          start_time: this.start_time,
          city: this.city,
          start_name: this.start_name,
          end_name: this.end_name,
        })
        .then((res) => {
          console.log(res);
          this.duration_time = res.duration_time;
          res.carTypeList.forEach((item, index) => {
            res.carList.forEach((car, i) => {
              if (item.id == car.id) {
                this.list.push({
                  name: item.car_type_name,
                  carList: car.value,
                  selected: false,
                });
              }
            });
          });
          this.mateCar();
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.allCarType {
  min-height: 100%;
  background: #ffffff;
  .nav {
    padding-top: 24px;
  }
  .isiOSX {
    padding-top: 44px;
  }
  .content {
    margin: 0 15px 120px;
    padding-top: 4px;
    .list {
      h2 {
        color: #333333;
        font-size: 20px;
        line-height: 28px;
        margin: 16px 0;
      }
      .out {
        // border: 1px solid blue;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .in {
          border: 3px solid #dddddd;
          border-radius: 5px;
          margin: 4px 0;
          width: 30%;
          .title {
            color: #666666;
            font-size: 12px;
            line-height: 17px;
            margin: 12px 0 0 12px;
          }
          .money {
            color: #333333;
            font-size: 12px;
            line-height: 28px;
            margin: 0 0 0 12px;
            span {
              font-size: 20px;
              line-height: 28px;
              font-weight: bolder;
            }
            .morlong {
              font-size: 16px;
            }
            img {
              width: 12px;
              height: 12px;
              transform: translateY(1px);
            }
          }
          .integral {
            color: #666666;
            font-size: 12px;
            line-height: 17px;
            margin: 0 0 0 12px;
            .activeIntegral {
              color: #ffb600;
            }
          }
          .carName {
            margin: 34px 12px 12px 12px;
            background: url(./../../assets/takingCar/unchecked.png) no-repeat
              center right;
            background-size: 16px;
            img {
              width: 14px;
              height: 14px;
              transform: translateY(3px);
            }
            color: #333333;
            font-size: 10px;
            line-height: 14px;
          }
        }
        .active {
          border: 3px solid #ffb600;
          .carName {
            background: url(./../../assets/takingCar/checked.png) no-repeat
              center right;
            background-size: 16px;
          }
        }
        &:after {
          content: "";
          width: 32%;
          display: block;
          height: 0;
          width: 31%;
        }
        @media screen and (max-width: 350px) {
          .in {
            .title {
              margin: 12px 0 0 4px;
            }
            .money {
              margin: 0 0 0 4px;
              span {
                font-size: 12px !important;
              }
            }
            .integral {
              margin: 0 0 0 4px;
            }
            .carName {
              margin: 34px 4px 12px 4px;
            }
          }
        }
      }
    }
  }
  .foot {
    height: 120px;
    background: #ffffff;
    box-shadow: 1px 1px 6px rgba(24, 24, 24, 0.1);
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;

    button {
      height: 45px;
      border-radius: 5px;
      font-size: 15px;
      line-height: 45px;
      margin-top: 20px;
      margin-left: 15px;
    }
    .left {
      width: 23%;
      // margin: 0px 15px 0;
      background: url(./../../assets/takingCar/unfold.png) no-repeat 74% center;
      background-size: 10px;
      background-color: #ffffff;
      color: #333333;
      text-align: left;
      padding: 0 0 0 6%;
      border: 1px solid #333333;
    }
    .right {
      // width: 65%;
      flex: 1;
      background: #181818;
      color: #ffffff;
      border: none;
      margin-right: 15px;
      .title {
        display: block;
        font-size: 15px;
        line-height: 21px;
      }
      .tip {
        font-size: 13px;
        display: block;
        line-height: 21px;
      }
    }
    .forbid {
      background: #e0e0e0;
    }
    @media screen and (max-width: 375px) {
      .left {
        background: url(./../../assets/takingCar/unfold.png) no-repeat 80%
          center;
        background-size: 10px;
        padding: 0 0 0 5%;
      }
    }
  }
}
</style>
